import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GlobalService } from 'src/app/api/global.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

export interface ColumnConfig {
  key: string;
  label: string;
  visible: boolean;
}

@Component({
  selector: 'app-column-picker',
  templateUrl: './column-picker.component.html',
  styleUrls: ['./column-picker.component.scss'],
})
export class ColumnPickerComponent implements OnInit {

  @Input() columns: ColumnConfig[] = [];
  @Input() header = 'Column Picker';
  @Input() selectLabel = 'Select columns to display:';
  @Input() confirmLabel = 'Apply';
  // Set false when the caller only honours visibility (not order), so the drag handles are hidden.
  @Input() allowReorder = true;

  constructor(private modalController: ModalController, public globalService: GlobalService) { }

  ngOnInit() {}

  // Only the eye icon shows / hides a column, so dragging or clicking the rest of the row can't change it by accident
  toggleColumn(column: ColumnConfig) {
    column.visible = !column.visible;
  }

  // Clicking the eye: flip the column and refresh the tooltip, which would otherwise keep saying the old action
  onEyeClick(column: ColumnConfig, event: Event) {
    event.stopPropagation();
    this.toggleColumn(column);
    this.globalService.ShowTooltip(event, column.visible ? 'Hide this column' : 'Show this column');
  }

  onDragStarted() {
    this.globalService.HideTooltip();
  }

  moveUp(index: number) {
    if (index > 0) moveItemInArray(this.columns, index, index - 1);
  }

  moveDown(index: number) {
    if (index < this.columns.length - 1) moveItemInArray(this.columns, index, index + 1);
  }

  showAll() {
    this.columns.forEach(col => col.visible = true);
  }

  hideAll() {
    this.columns.forEach(col => col.visible = false);
  }

  drop(event: CdkDragDrop<ColumnConfig[]>) {
    moveItemInArray(this.columns, event.previousIndex, event.currentIndex);
  }

  async Save() {
    this.modalController.dismiss({ columns: this.columns });
  }

  async Close() {
    this.modalController.dismiss();
  }

}
